import isString from 'lodash/isString';
import URI from 'urijs';
import { toUnicode } from './punycode';

var HOSTNAME_REGEXP = /^(([а-яa-z0-9]|[а-яa-z0-9][а-яa-z0-9-]*[а-яa-z0-9])\.)*([а-яa-z0-9]|[а-яa-z0-9][а-яa-z0-9-]*[а-яa-z0-9])$/i;

/**
 * Ендпоинт для получения фавиконки сайтов
 * @type {String}
 */
export var FAVICON_GETTER_URL = 'https://favicon.yandex.net/favicon/';

/**
 * Получение ссылки на фавиконку
 * @param  {String} domain
 * @return {String}
 */
export var getFaviconUrl = function getFaviconUrl(domain) {
    return '' + FAVICON_GETTER_URL + domain;
};

/**
 * Схема для base64 ссылки
 * @type {String}
 */
export var BASE64_SCHEMA = 'data:image/png;base64,';

/**
 * Добавление к base64 строке схемы
 * @param  {String} base64String
 * @return {String}
 */
export var getBase64Url = function getBase64Url(base64String) {
    return '' + BASE64_SCHEMA + base64String;
};

/**
 * Возвращает пути и запрос
 * @param  {URI|String} url
 * @return {String}
 */
export function getPath(url) {
    url = getURI(url);

    var tail = (url.path() + url.search()).replace(/^\/|\/$/g, '');

    try {
        return URI.decode(tail);
    } catch (e) {
        return tail;
    }
}

/**
 * Возвращает ориджин
 * @param  {URI|String} url
 * @return {String}
 */
export function getOrigin(url) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$punycode = _ref.punycode,
        punycode = _ref$punycode === undefined ? false : _ref$punycode;

    url = getURI(url).normalizeHostname();
    var origin = url.origin();

    if (punycode) {
        return punycodeToUnicode(url, url.origin());
    }

    return origin;
}

/**
 * Возвращает имя домэна
 * @param  {URI|String} url
 * @return {String}
 */
export function getHostname(url) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$www = _ref2.www,
        www = _ref2$www === undefined ? false : _ref2$www,
        _ref2$punycode = _ref2.punycode,
        punycode = _ref2$punycode === undefined ? true : _ref2$punycode,
        _ref2$tld = _ref2.tld,
        tld = _ref2$tld === undefined ? true : _ref2$tld;

    url = getURI(url).clone().normalizeHostname();

    if (!url.is('absolute') || !url.is('domain')) {
        return url.hostname();
    }

    var hostname = void 0;

    if (!www) {
        var subdomains = url.subdomain().split('.');

        if (subdomains[0] === 'www') {
            hostname = url.hostname().split('.').splice(1).join('.');
        } else {
            hostname = url.hostname();
        }
    } else {
        hostname = url.hostname();
    }

    if (!tld) {
        hostname = hostname.replace(new RegExp('\\.' + url.tld() + '$'), '');
    }

    if (punycode) {
        return punycodeToUnicode(url, hostname);
    }

    return hostname;
}

export function punycodeToUnicode(url, data) {
    var isPunycode = url.is('punycode');

    if (arguments.length === 1) {
        return isPunycode ? url.domain(toUnicode(url.domain())).toString() : url.toString();
    }

    return url.is('punycode') ? toUnicode(data).toLowerCase() : data;
}

export function parseUrl(href) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref3$validateHostnam = _ref3.validateHostname,
        validateHostname = _ref3$validateHostnam === undefined ? true : _ref3$validateHostnam;

    var url = void 0;

    try {
        url = new URI(href);
    } catch (e) {
        return null;
    }

    if (!url) {
        return null;
    }

    if (!url.protocol()) {
        url = new URI(url.protocol('http').toString());
    }

    if (!validateHostname) {
        return url;
    }

    if (!checkHostname(url)) {
        return null;
    }

    return url;
}

function getURI(url) {
    return isString(url) ? new URI(url) : url;
}

/**
 * Проверка имени хоста
 * @param {URI} url
 * @return {Boolean}
 */
export var checkHostname = function checkHostname(url) {
    if (!url.hostname()) {
        return false;
    }

    if (url.is('domain') && !HOSTNAME_REGEXP.test(url.clone().normalizeHostname().hostname())) {
        return false;
    }

    return true;
};